import Translatable from '@/app-core/mixins/translatable'
import {getContrastColor} from '@/app-core/lib/utils/color'

export default {
  name      : 'ProductTags',
  components: {},
  directives: {},
  mixins    : [Translatable],
  props     : {
    tags: {
      type   : Array,
      default: undefined
    },
    iconOnly: {
      type   : Boolean,
      default: false
    },
    xSmall: {
      type   : Boolean,
      default: false
    },
    small: {
      type   : Boolean,
      default: false
    },
    large: {
      type   : Boolean,
      default: false
    },
    xLarge: {
      type   : Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {
    tagsList() {
      return this.tags?.filter(tag => tag.Active && tag.Visible && !tag.System) || []
    }
  },
  watch: {},
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {
    getContrastColor
  }
}
